import { GoalBasedFinancialPlanRetirementHorizonResponse } from "@fartherfinance/frontend/api/FinancialPlans/retirementHorizon/types";
import {
  GoalBasedPlanDateResponse,
  GoalBasedPlanDateTypeSchema,
} from "@fartherfinance/frontend/api/FinancialPlans/types";
import { ClientId } from "@fartherfinance/frontend/api/Types";

import {
  AlreadyStartedOption,
  CalendarYearOption,
  EndOfSpousesPlanningHorizonOption,
  EndOfYourPlanningHorizonOption,
  SpousesAgeOption,
  SpousesRetirementOption,
  YourAgeOption,
  YourRetirementOption,
} from "../constants";

import type { PlanDateTypeOptionsDropdown } from "../Types";

export const getOptionForStartEndPlanDateField = (
  planDate: GoalBasedPlanDateResponse | undefined,
  owner: ClientId | undefined,
  clientId: ClientId,
  retirementHorizons:
    | GoalBasedFinancialPlanRetirementHorizonResponse[]
    | undefined
): PlanDateTypeOptionsDropdown | undefined => {
  if (planDate === undefined) {
    return undefined;
  }

  const { AlreadyStarted, Age, DateString, Year } =
    GoalBasedPlanDateTypeSchema.Enum;

  const isNotSpouse = owner === undefined || clientId === owner;

  if (retirementHorizons !== undefined) {
    const retirement = retirementHorizons.find(
      (rh) => rh.startDate?.planDateId === planDate.planDateId
    );

    if (retirement !== undefined) {
      return retirement.owner === clientId
        ? YourRetirementOption
        : SpousesRetirementOption;
    }

    const horizon = retirementHorizons.find(
      (rh) => rh.endDate?.planDateId === planDate.planDateId
    );

    if (horizon !== undefined) {
      return horizon.owner === clientId
        ? EndOfYourPlanningHorizonOption
        : EndOfSpousesPlanningHorizonOption;
    }
  }

  switch (planDate.dateType) {
    case AlreadyStarted:
      return AlreadyStartedOption;
    case DateString:
    case Year:
      return CalendarYearOption;
    case Age:
      return isNotSpouse ? YourAgeOption : SpousesAgeOption;
    default:
      return undefined;
  }
};
